import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { UserService } from 'app/core/user/user.service';
import { User } from 'app/core/user/user.types';
import { CountryZone } from 'app/modules/admin/apps/country-zone/country-zone.types';
import { UserSelectorService } from 'app/services/userSelector.service';

@Component({
  selector: 'app-user-selector',
  templateUrl: './user-selector.component.html',
  styles: [],
})
export class UserSelectorComponent implements OnInit {
  @ViewChild('countryZoneSearch')
  countryZoneSearchInput!: ElementRef<HTMLInputElement>;
  filterCountryInputControl: UntypedFormControl = new UntypedFormControl();

  allCountryZone: CountryZone[] = [];
  userInfo: User;

  constructor(
    private userService: UserService,
    private userSelectorService: UserSelectorService
  ) {}

  ngOnInit(): void {
    this.userInfo = this.userService.currentUser;
    this.allCountryZone = this.userInfo.countryManage;

    this.allCountryZone = this.allCountryZone.filter(
      (cz) => cz.enable === true
    );
    this.allCountryZone.sort(this.sortByTitle);

    this.filterCountryInputControl.patchValue(
      this.userSelectorService._countryZoneCode.value
    );
  }

  onSelectCountry(countryZoneCode: string[]): void {
    let newList = countryZoneCode;

    const searchValue = this.countryZoneSearchInput?.nativeElement?.value;
    if (searchValue) {
      newList = Array.from(
        new Set([
          ...newList,
          ...this.userSelectorService._countryZoneCode.value,
        ])
      );
    }

    this.filterCountryInputControl.patchValue(newList);
    this.userSelectorService.updateCountryZoneCode(newList);
  }

  trackByFn(index: number, item: CountryZone): any {
    return item.countryZoneCode;
  }

  sortByTitle(a: CountryZone, b: CountryZone): number {
    const titleA = a.name.toLowerCase();
    const titleB = b.name.toLowerCase();

    if (titleA < titleB) {
      return -1;
    }
    if (titleA > titleB) {
      return 1;
    }
    return 0;
  }

  isAllSelected(): boolean {
    return (
      this.filterCountryInputControl.value.length === this.allCountryZone.length
    );
  }

  toggleSelectAll(): void {
    if (this.isAllSelected()) {
      this.userSelectorService.updateCountryZoneCode([]);
      this.filterCountryInputControl.patchValue([]);
    } else {
      const listCZAll = this.allCountryZone.map((cz) => cz.countryZoneCode);
      this.filterCountryInputControl.patchValue([...listCZAll]);
      this.userSelectorService.updateCountryZoneCode([...listCZAll]);
    }
  }
}
